export const modalTableConfig = {
  title: '通话明细查询',
  propList: [
    {
      prop: 'customName',
      label: '名称',
      minWidth: '120',
      slotName: 'customName'
    },
    { prop: 'customId', label: 'ID', minWidth: '80' },
    {
      prop: 'msgTime',
      label: '开始时间',
      minWidth: '120',
      slotName: 'beginTime',
      sortable: true
    },
    {
      prop: 'endTime',
      label: '结束时间',
      minWidth: '120',
      slotName: 'endTime',
      sortable: true
    },
    {
      prop: 'duration',
      label: '通话时长',
      minWidth: '120',
      slotName: 'duration',
      sortable: true
    },
    { prop: 'actionName', label: '主叫/被叫', minWidth: '80' }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
